/**
 * The questionnaire sequence every visitor starts. It was chosen per visitor by
 * the `show_new_feature_v1` flag during the June 2026 A/B test; the new sequence
 * was adopted, so the choice is no longer a flag.
 */
export const SEQUENCE_ID = '6ddb207c-0acc-4c21-b84e-7951263c8f99';

export function getSequenceId(): string {
  return SEQUENCE_ID;
}
